import { Organization, UpdateOrganizationDTO } from 'types/organization';
import useNotify from 'hooks/useNotify';
import useLazyResource from 'util/resource/useLazyResource';
import OrganizationAPI from 'apis/OrganizationAPI/index';
import { invalidate } from 'hooks/useSWR';

export const useUpdateOrganization = (
  organization: Organization,
  options?: { onSuccess?: () => void; onFailure?: () => void },
) => {
  const notify = useNotify();

  return useLazyResource(
    (update: Partial<UpdateOrganizationDTO>) =>
      OrganizationAPI.update(organization.profile.id, {
        name: organization.profile.name,
        description: organization.details.description,
        website: organization.details.website,
        location: organization.details.location,
        established: organization.profile.established?.toString(),
        logoUrl: organization.profile.logoURL,
        bannerUrl: organization.details.bannerUrl,
        ...update,
      }),
    {
      onSuccess: (result: Organization) => {
        options?.onSuccess && options.onSuccess();
        invalidate(OrganizationAPI.getBySlug(organization.profile.slug), result);
        invalidate(OrganizationAPI.listAllUsersUrl(organization.profile.id));
      },
      onFailure: () => {
        options?.onFailure && options.onFailure();
        notify('error', `Something unexpected happened when trying to update organization information.`);
      },
    },
  );
};
